import React from "react";

import ColumnSvg from "../../assets/images/icons/Form Controls/Column.svg";

export const ColumnIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={ColumnSvg}
        alt={alt || "Column"}
    />
);
